import { phoneRegex } from "@homeinstead/shared";
import { z } from "zod";

export const phone = z
  .string()
  .min(1, { error: "Phone Number is required" })
  .regex(phoneRegex, {
    error: "Phone number must be a valid US or Canadian number",
  });
